<template>
  <div class="qualityPage">
    <div class="aBox1">
      <img
        class="ab1Img"
        src="http://cdn.xiyundata.com/crane_index/version3/v3service01.png"
        alt=""
      />
      <img
        class="ab1Img2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3service02.png"
        alt=""
      />
    </div>
    <div class="aBox2">
      <div class="aBox2Content">
        <div class="ab2Title">数港物联一站式智慧应力管理方案</div>
        <div class="ab2Content">
          数港物联承诺，为全国客户提供起重机应力监测的坚实保障在您选择数港物联的服务后，我们将持续为起重机应力管理增值<br/>赋能，促进您的业务稳健高效运行凭借智慧应力管理系统，在港口、工厂、物流园区等关键作业场景我们打造覆盖起重机全<br/>生命周期的智·慧服务，实现全程护航，为您提供从源头到终端的高品质服务体验
        </div>
      </div>
    </div>
    <div class="qBox3">
      <img class="qb3Img" src="http://cdn.xiyundata.com/crane_index/quality04.jpg" alt="">
    </div>
    <div class="qBox4">
      <div class="qb4Content">
        <div class="qb4Line1">数港物联一站式智慧应力管理方案</div>
        <div class="qb4Line3">
          数港物联承诺，为全国客户提供起重机应力监测的坚实保障在您选择数港物联的服务后，我们将持续为起重机应力管理增值赋能，促进您的业务稳健高效运行凭借智慧应力管理系统，在港口、工厂、物流园区等关键作业场景我们打造覆盖起重机全生命周期的智·慧服务，实现全程护航，为您提供从源头到终端的高品质服务体验
        </div>
      </div>
    </div>
    <div class="qBox5">
      <div class="qb5Content">
        <div class="swpItem" style="margin-left: 50px">
          <img
            class="swiperImg"
            src="http://cdn.xiyundata.com/crane_index/quality01.jpg"
            alt=""
          />
          <!-- <p class="swiperTxt">服务标准履约追踪掌控</p> -->
        </div>
        <div class="swpItem">
          <img
            class="swiperImg"
            src="http://cdn.xiyundata.com/crane_index/quality02.jpg"
            alt=""
          />
          <!-- <p class="swiperTxt">服务工单全流程可视化</p> -->
        </div>
        <div class="swpItem">
          <img
            class="swiperImg"
            src="http://cdn.xiyundata.com/crane_index/quality03.jpg"
            alt=""
          />
          <!-- <p class="swiperTxt">备件安全库存智能备货</p> -->
        </div>
        <div class="swpItem" style="margin-right: 50px">
          <img
            class="swiperImg"
            src="http://cdn.xiyundata.com/crane_index/quality05.jpg"
            alt=""
          />
          <!-- <p class="swiperTxt">项目运维数据多维度统计</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script >
export default {
  data() {
    return {};
  },
  methods: {
    handleScroll() {
      // 淡入动画
      const qBox3 = this.$el.querySelector(".qBox3");
      const qBox3Top = qBox3.offsetTop;
      const windowHeight = window.innerHeight;
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (
        scrollPosition + windowHeight > qBox3Top &&
        scrollPosition < qBox3Top + qBox3.offsetHeight
      ) {
        qBox3.classList.add("fade-in-animation");
      } else {
        qBox3.classList.remove("fade-in-animation");
      }

      const qBox4 = this.$el.querySelector(".qBox4");
      const qBox4Top = qBox4.offsetTop;
      if (
        scrollPosition + windowHeight > qBox4Top &&
        scrollPosition < qBox4Top + qBox4.offsetHeight
      ) {
        qBox4.classList.add("fade-in-animation");
      } else {
        qBox4.classList.remove("fade-in-animation");
      }

      const qb5Content = this.$el.querySelector(".qb5Content");
      const qb5ContentTop = qb5Content.offsetTop;
      if (
        scrollPosition + windowHeight > qb5ContentTop &&
        scrollPosition < qb5ContentTop + qb5Content.offsetHeight
      ) {
        qb5Content.classList.add("fade-in-animation");
      } else {
        qb5Content.classList.remove("fade-in-animation");
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
  
  <style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.qualityPage {
  /* padding-top: 70px; */
}
.aBox1 {
  width: 100vw;
}
.ab1Img {
  width: 100%;
}
.ab1Img2 {
  width: 100%;
}
.aBox2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 400px;
  background: #F5F5F7;
}
.aBox2Content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1225px;
  height: auto;
}
.ab2Title {
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
}
.ab2Content {
  line-height: 30px;
  margin-top: 26px;
  font-size: 16px;
  color: #262626;
  text-align: center;
}
.qBox3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  /* height: 100vh; */
  background: radial-gradient(circle at left, #0103ff, #2ae1d7);
}
.qb3Img {
  width: 100%;
  /* height: 100%; */
}
.qBox4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 345px;
  background: #F5F5F7;
}
.qb4Content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1200px;
  height: 100%;
}
.qb4Line1 {
  width: 100%;
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
}
.qb4Line3 {
  text-align: left;
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.qBox5 {
  display: flex;
  width: 100vw;
  height: 425px;
  background: #F5F5F7;
  padding-bottom: 50px;
}
.qb5Content {
  display: flex;
  /* width: 1411px; */
  overflow-x: scroll;
  height: 100%;
}

.qb5Content::-webkit-scrollbar {
  height: 6px; /* 设置滚动条的高度 */
}

.qb5Content::-webkit-scrollbar-thumb {
  background-color: #c1c1c1; /* 设置滚动条的背景颜色 */
  border-radius: 3px; /* 设置滚动条的圆角 */
}

.qb5Content::-webkit-scrollbar-track {
  background-color: #eeeeee; /* 设置滚动条轨道的背景颜色 */
}
.swpItem {
  margin-right: 20px;
}
.swiperImg {
  width: 400px;
  border-radius: 10px;
}
.swiperTxt {
  color: #999;
  line-height: 3;
  font-size: 17px;
}

.fade-in-animation {
  animation: fade-in 1.1s ease-in-out forwards;
}

/* 淡入动画 */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}


@media (max-width: 830px) {
  .ab1Img {
    display: none;
  }
  .ab1Img2 {
    display: block;
  }
  .aBox2 {
    height: auto;
  }
  .aBox2Content {
    padding-top: 40px;
    padding-left: 30px;
    padding-right: 30px;
  }
  .ab2Title {
    font-size: 23px;
  }
  .ab2Content {
    font-size: 12px;
  }
  .ab2Content {
    margin-bottom: 40px;
  }
  .qBox3 {
    width: 100%;
    /* height: auto; */
  }
  .qb4Content {
    width: 80%;
  }
  .qb4Line1 {
    font-size: 23px;
  }
  .qb4Line3 {
    font-size: 12px;
  }
  .qBox5 {
    height: auto;
    justify-content: center;
  }
  .qb5Content{
    width: 90%;
    flex-direction: column;
    height: auto;
    overflow: hidden;
  }
  .swpItem {
    position: relative;
    width: 100%;
    height: 300px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: 10px;
  }
  .swiperImg {
    height: 100%;
    width: 100%;
    object-fit: cover; /* 确保图片覆盖整个容器 */
  }
  .swiperTxt {
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #fff;
  }
}

@media (min-width: 830px) {
  .ab1Img {
    display: block;
  }
  .ab1Img2 {
    display: none;
  }
}
</style>
  